
import { defineComponent } from "vue";

type Props = {
  text: string
};

export default defineComponent({
  name: "QuoteFacebook",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  setup(props: Props) {
    const fbWindow = () => {
      let url = `https://www.facebook.com/share.php?quote=${props.text}&u=${window.location.href}`;
      let width = 575;
      let height = 630;
      let features = "location=no, menubar=no, status=yes, scrollbars=yes, resizable=yes, toolbar=no";
      features += ", left=" + (window.screen.width - width) / 2;
      features += ", width=" + width;
      features += ", top=" + (window.screen.height - height) / 2;
      features += ", height=" + height;

      window.open(url, "_blank", features);
    };
    return {
      fbWindow
    };
  }
});
